// extracted by mini-css-extract-plugin
export default {"propertyInput":"PropertyInput_propertyInput__wVrO4"};